import { toast } from 'sonner'
import axiosInstance from '../api/axiosInstance'
import logger from '../utils/logger'

export async function userRegisterService(formData) {
  const { data } = await axiosInstance.post('/register', {
    ...formData,
  })

  return data
}

export async function businessRegisterService(formDataObject) {
  try {
    const formData = new FormData()
    // Append basic text fields
    formData.append('business_name', formDataObject.business_name)
    formData.append('email', formDataObject.email)
    formData.append('mobile', formDataObject.mobile)
    formData.append('business_type', formDataObject.business_type)
    formData.append('address', formDataObject.address)
    formData.append('country_code', formDataObject.country_code)
    formData.append('acceptTerms', formDataObject.acceptTerms)

    // Append actual File objects from `formDataObject.documents`
    if (Array.isArray(formDataObject.documents)) {
      formDataObject.documents.forEach((doc) => {
        formData.append(doc.key, doc.value)
      })
    }
    const response = await axiosInstance.post('/register-business', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response
  } catch (error) {
    logger.error('Error in business register service:', error)
    throw error
  }
}

export async function businessLoginService(formData) {
  try {
    const response = await axiosInstance.post('/login-business', formData)

    return response // Return the entire response object
  } catch (error) {
    logger.error('Error in business register service:', error)
    throw error
  }
}

export async function userLoginService(formData) {
  try {
    const response = await axiosInstance.post('/login', formData)

    return response // Return the entire response object
  } catch (error) {
    logger.error('Error in business register service:', error)
    throw error
  }
}

// -------- for send business otp ---------
export async function sendBusinessOtp() {
  try {
    const response = await axiosInstance.post('/send-business-otp')

    return response // Return the whole response object
  } catch (error) {
    logger.error('Error in sendBusinessOtp service:', error)
    throw error
  }
}

// -------- for verify user otp ---------
export async function verifyOtp(formData) {
  try {
    const response = await axiosInstance.post('/verify-otp', formData)

    return response // Return the entire response object
  } catch (error) {
    logger.error('Error in verifyOtp service:', error)
    throw error
  }
}

// -------- for verify business otp ---------
export async function verifyBusinessOtp(formData) {
  try {
    const response = await axiosInstance.post('/verify-business-otp', formData)

    return response // Return the entire response object
  } catch (error) {
    logger.error('Error in verifyBusinessOtp service:', error)
    throw error
  }
}

export async function checkAuthService() {
  const { data } = await axiosInstance.get('/check-auth')

  return data
}

export async function generateQrCodeService() {
  const { data } = await axiosInstance.get('/generate-qr')

  return data
}

export async function forgotPasswordService(formData) {
  try {
    const response = await axiosInstance.post('/forgotPassword', formData)

    return response // Return the entire response object
  } catch (error) {
    logger.error('Error in business register service:', error)
    throw error
  }
}

export async function createEnquiry(payload) {
  try {
    const response = await axiosInstance.post('/add-enquiry', payload)

    return response.data // return the response data
  } catch (error) {
    logger.error('Error in createEnquiry:', error)
    throw error
  }
}

export async function createSubscriptionService({ paymentMethodId, name, email, priceId }) {
  try {
    const response = await axiosInstance.post('/create-subscription', {
      paymentMethod: paymentMethodId,
      name,
      email,
      priceId,
    })

    return response.data // return the response data
  } catch (error) {
    logger.error('Error in createSubscriptionService:', error)
    throw error
  }
}

export async function getCheckoutSession({ sessionId }) {
  try {
    if (!sessionId) throw new Error('Missing sessionId')

    const response = await axiosInstance.get(
      `/stripe/checkout-session?sessionId=${encodeURIComponent(sessionId)}`
    )

    return response.data
  } catch (error) {
    logger.error('Error in getCheckoutSession:', error)
    throw error
  }
}

export async function createCheckoutSessionService(payload) {
  try {
    if (!payload) throw new Error('Missing payload')

    const response = await axiosInstance.post(`/stripe/create-checkout-session`, payload)

    return response.data
  } catch (error) {
    logger.log(error)
    throw new Error('Error in create checkout session')
  }
}

export async function getBusinessSubscriptionService() {
  try {
    const response = await axiosInstance.get('/subscription')
    return response
  } catch (error) {
    logger.error('Error in getBusinessSubscriptionService:', error)
    throw new Error('Error in getBusinessSubscriptionService')
  }
}

export async function getBusinessInvoicesService(page = 1, limit = 10) {
  try {
    const response = await axiosInstance.get('/invoices', {
      params: { page, limit },
    })
    return response
  } catch (error) {
    logger.error('Error in getBusinessInvoicesService:', error)
    throw new Error('Error in getBusinessInvoicesService')
  }
}

export async function cancelSubscriptionService() {
  try {
    const response = await axiosInstance.post('/stripe/cancel-subscription')
    return response
  } catch (error) {
    logger.error('Error in cancelSubscriptionService:', error)
    throw new Error('Failed to cancel subscription')
  }
}

export async function reactivateSubscriptionService() {
  try {
    const response = await axiosInstance.post('/stripe/reactivate-subscription')
    return response
  } catch (error) {
    logger.error('Error in reactivateSubscriptionService:', error)
    throw new Error('Failed to reactivate subscription')
  }
}

export async function createCustomerPortalSessionService(return_url, successPageUrl, priceId) {
  try {
    const response = await axiosInstance.post('/stripe/create-customer-portal-session', {
      return_url,
      successPageUrl,
      priceId,
    })
    return response.data
  } catch (error) {
    logger.error('Error in createCustomerPortalSessionService:', error)
    throw new Error('Failed to create customer portal session')
  }
}

export async function createCustomerHomePortalSessionService(return_url, successPageUrl) {
  try {
    const response = await axiosInstance.post('/stripe/create-customer-home-portal-session', {
      return_url,
    })
    return response.data
  } catch (error) {
    logger.error('Error in createCustomerHomePortalSessionService:', error)
    throw new Error('Failed to create customer portal session')
  }
}

export async function upgradeSubscriptionService({ priceId }) {
  try {
    const response = await axiosInstance.post('/stripe/upgrade-subscription', {
      priceId,
    })

    return response.data
  } catch (error) {
    logger.error('Error in upgradeSubscriptionService:', error)
    throw new Error(error.response?.data?.error || 'Failed to upgrade subscription')
  }
}

export async function saveCardInfoService({ paymentMethodId, priceId }) {
  try {
    const response = await axiosInstance.post('/stripe/save-card-info', {
      paymentMethodId,
      priceId,
    })

    return response.data
  } catch (error) {
    logger.error('Error in saveCardInfoService:', error)
    // Providing a more general error message for the user if the specific error message is not available
    throw new Error(error.response?.data?.error || 'Failed to save card information.')
  }
}

export async function getAllPlansService(businessId = null, testIp = null) {
  try {
    const publicIP = await fetch('https://api.ipify.org?format=json')
    const data = await publicIP.json()
    testIp = data.ip
    // Construct query parameters
    const params = {}
    if (businessId) {
      params.businessId = businessId
    }

    // Construct headers, conditionally adding X-Forwarded-For for testing
    const headers = {}
    if (testIp) {
      headers['X-Forwarded-For'] = testIp
      logger.info(`getAllPlansService: Sending X-Forwarded-For header for testing: ${testIp}`)
    }

    // Make the Axios GET request with parameters and headers
    const response = await axiosInstance.get('/web-api/get-all-plans', {
      params: params,
      headers: headers, // Pass the headers object here
    })

    if (response.status === 200 && Array.isArray(response.data.data)) {
      return response.data.data
    } else {
      logger.warn(
        'getAllPlansService: Received unexpected data format or empty data array from backend.',
        response.data
      )
      return []
    }
  } catch (error) {
    logger.error(
      'Error in getAllPlansService:',
      error.response?.data?.message || error.message || error
    )
    throw new Error(error.response?.data?.message || 'Failed to fetch pricing plans.')
  }
}

export async function getConfig(params) {
  try {
    const response = await axiosInstance.get('config/get-configuration', {
      params: params,
    })
    return response.data
  } catch (error) {
    console.error('Error fetching profile:', error)
    toast.error('Failed to fetch profile data')
  }
}

/* ===========================  WALLET NOTIFICATION SERVICES START ==================      */

// Create and send wallet notification
export async function createWalletNotification(data) {
  try {
    const response = await axiosInstance.post('/wallet-notifications/send', data)
    return response.data
  } catch (error) {
    console.error('Error creating wallet notification:', error)
    throw error
  }
}

// Get my business wallet notifications
// Get my business wallet notifications
export async function getMyWalletNotifications(params = {}) {
  try {
    const { data } = await axiosInstance.get('/wallet-notifications/my', {
      params,
    })
    return data
  } catch (error) {
    console.error('Error fetching my notifications:', error)

    const message = error?.response?.data?.message || 'Failed to fetch wallet notifications'
    toast.error(message)

    // Return empty data instead of crashing
    return {
      notifications: [],
      total: 0,
      totalPages: 0,
      currentPage: 1,
      limit: params?.limit || 10,
    }
  }
}

// Get all wallet notifications (admin only)
export async function getAllWalletNotifications(params) {
  try {
    const response = await axiosInstance.get('/wallet-notifications', { params })
    return response.data
  } catch (error) {
    console.error('Error fetching all notifications:', error)
    toast.error(error?.response?.data?.message || 'Failed to fetch all notifications')
    throw error
  }
}

// Get a single notification by ID
export async function getWalletNotificationById(id) {
  try {
    const response = await axiosInstance.get(`/wallet-notifications/${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching notification by ID:', error)
    toast.error(error?.response?.data?.message || 'Failed to fetch notification details')
    throw error
  }
}

// Delete notification
export async function deleteWalletNotification(id) {
  try {
    const response = await axiosInstance.delete(`/wallet-notifications/${id}`)
    toast.success('Notification deleted successfully')
    return response.data
  } catch (error) {
    console.error('Error deleting notification:', error)
    toast.error(error?.response?.data?.message || 'Failed to delete notification')
    throw error
  }
}

/* ===========================  WALLET NOTIFICATION SERVICES END ==================      */

export async function updateCustomerStatus(id, isCustomerActive) {
  try {
    const response = await axiosInstance.patch(`/business/customers/${id}/status`, {
      isCustomerActive,
    })
    // toast.success('Customer status updated successfully')
    return response.data
  } catch (error) {
    console.error('Error updating customer status:', error)
    toast.error(error?.response?.data?.message || 'Failed to update customer status')
    throw error
  }
}
